import React  from "react";
import { Switch, HashRouter } from "react-router-dom";

import "./App.scss";
import CalenderPage from "./components/guest-layout/CalenderComponent";
import Excursion_component from "./components/guest-layout/excursions";
import Adventure_info from "./components/guest-layout/adventure-info/Adventure_info";
import CartDetails from "./components/user-layout/CartDetails";
import PaymentDetails from "./components/user-layout/Payment_Details";
import Routes from "./routes/privateRoutes/Routes";
import OpenRoutes from "./routes/privateRoutes/OpenRoutes";
import FinishModal from "./components/layout/Modals/FinishModal";
import SpecialIns from "./components/layout/Modals/SpecialInstrucModal";
import AddDetails from "./components/layout/Modals/Add_Details_Modal";
import ScrollToTop from "./shared/scrollTop";
import { CancelSuccess, PaymentSuccess } from "./components/user-layout/Success";
import UserDetails from "./components/user-layout/UserDetails";
import PassengerDetails from "./components/user-layout/PassengerDetails";

// import Auth from "../../auth/Auth";

// import { get, handleError } from "./shared/HttpReq";
// import AppContext from "./shared/AppContext";

function App() {

  
  /*
  
  1. move API function
  2. use UseEffect to call that function
  3. Use UseContext that we created.. to save company information
  4.   
  
  */

  //function for get company name

  // const { companyInfo, cartValue } = useContext(AppContext);
  // const [excursionList, setExcursionData] = useState([]);



  // Auth.setCompanyHexaID(query.get("id"));

  // //for getting company id
  // const getCompanyDetail = async () => {
  //   setLoading(true);
  //   let res = await handleError(
  //     await fetch(
  //       `${process.env.REACT_APP_BASE_URL}/company-link/${query.get("id")}`,
  //       await get()
  //     )
  //   );
   
  //   setCompanyInfo({ name: res.name })

  //   if (res.status === 200) {
  //     companyId = res._id;
  //     Auth.setCompanyID(companyId);
  //     getPhotoDetail();
  //     setExcursionData(res.data);
  //   }
  // };

  return (
    <HashRouter>
      <ScrollToTop> </ScrollToTop>
        <Switch>
          <OpenRoutes exact path="/paypal/success" component={PaymentSuccess} />
          <OpenRoutes exact path="/paypal/cancel" component={CancelSuccess} />
          <Routes exact path="/" component={CalenderPage} />
          
          <Routes exact path="/excursion" component={Excursion_component} />
          <Routes
            exact
            path="/Adventure_info/:companyId/:excursionId"
            component={Adventure_info}
          />
          <Routes
            exact
            path="/CartDetails/:companyId"
            component={CartDetails}
          />
              <Routes
            exact
            path="/CartDetails"
            component={CartDetails}
          />
          <Routes
            exact
            path="/PaymentDetails/:orderId"
            component={PaymentDetails}
          />
            <Routes
            exact
            path="/user-details"
            component={UserDetails}
          />
                <Routes
            exact
            path="/passenger-details"
            component={PassengerDetails}
          />
          <Routes exact path="/SpecialIns" component={SpecialIns} />
          <Routes exact path="/FinishModal" component={FinishModal} />

          <Routes exact path="/Add_Details" component={AddDetails} />
        </Switch>
    </HashRouter>
  );
}

export default App;
